// Master JS for the home page

import BootstrapModal from "bootstrap/js/dist/modal";

// fslightbox has no exports - importing it runs its self-init, which scans for
// [data-fslightbox] elements. Module scripts are deferred, so the DOM is ready.
import "fslightbox";

// Partner welcome modal, only rendered on the /caringbridge and /mmt routes
const partnerModal = document.getElementById("pg-partner-modal");
if (partnerModal) {
    new BootstrapModal(partnerModal).show();
}
